import $ from "jquery";

const MenuDropdown = (el) => {
    const $el = $(el);

    $el.click(function (e) {
        e.preventDefault();

        const isOpen = $el.hasClass("js-state-menu-dropdown-open");

        if (isOpen) {
            $el.removeClass("js-state-menu-dropdown-open");
            $el.attr("aria-expanded", "false");
        } else {
            $(".menu__dropdown-button")
                .removeClass("js-state-menu-dropdown-open")
                .attr("aria-expanded", "false");
            $el.addClass("js-state-menu-dropdown-open").attr(
                "aria-expanded",
                "true"
            );
        }
    });
};

export default MenuDropdown;
